export const sendContactDetails = "SEND_CONTACT_DETAILS"
export const getContactDetails  = "GET_CONTACT_DETAILS"

export const LOGIN_USER = 'easyplatter/user/LOGIN_USER';
export const LOGIN_USER_FAILED = 'easyplatter/user/LOGIN_USER_FAILED';
export const LOGIN_USER_SUCCESS = 'easyplatter/user/LOGIN_USER_SUCCESS';

export const LOGOUT_USER = 'easyplatter/user/LOGOUT_USER';
export const LOGOUT_USER_FAILED = 'easyplatter/user/LOGOUT_USER_FAILED';
export const LOGOUT_USER_SUCCESS = 'easyplatter/user/LOGOUT_USER_SUCCESS';